// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"c25d0c22","773":"428027cc"}[chunkId] + ".chunk.css";
};